import { render, staticRenderFns } from "./FeatureSurvey.vue?vue&type=template&id=39018ee4&"
import script from "./FeatureSurvey.vue?vue&type=script&lang=ts&"
export * from "./FeatureSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports